import React, { useLayoutEffect } from "react";
import { BarChart, Bar, ResponsiveContainer } from "recharts";
import getSignedUrlAzure from "src/main_app/services/apis/devices-download-file-azure";
import getDeviceDownloadFileJsonAzure from "src/main_app/services/apis/devices-download-file-json-azure";
import downloadBlobAzure from "src/main_app/services/apis/devices-download-blob-azure";
import { getApiUrl } from "src/main_app/utils/config-utility";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { saveAs } from "file-saver";
import JSZip from "jszip";

const DeviceItem = ({ tenantConfig, titleHunt, device, date }) => {
  const displaySeverity = (title, type) => {
    return (
      <span className={`alert-severity alert-severity--${type}`}>{title}</span>
    );
  };

  const downloadFile = async (date, participantCodes) => {
    if (tenantConfig?.slug === "demowater") {
      const { data } = await getDeviceDownloadFileJsonAzure(participantCodes);

      if ((data || []).length === 0) return;

      const confirmed = window.confirm(
        `Do you want to download ${data.length} files?`
      );

      if (!confirmed) return;

      const zip = new JSZip();

      for (const { fileName, signedUrl } of data) {
        try {
          const res = await downloadBlobAzure({ signedUrl });

          // Convert JSON object to string if needed
          const content =
            typeof res.data === "object"
              ? JSON.stringify(res.data, null, 2)
              : res.data;

          zip.file(fileName, content);
        } catch (err) {
          console.error(`Failed to download ${fileName}`, err);
        }
      }

      // Create ZIP
      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(zipBlob, "device_files.zip");
    } else {
      const response = await getSignedUrlAzure(date);
      saveAs(response.data, "device_data_" + date + ".csv");
    }
  };

  useLayoutEffect(() => {
    import("./style.scss");
  }, []);

  //check if tenant is ICON to check with device.signal_strength else show the current return
  const shouldRenderDevice = () => {
    if (tenantConfig?.slug === "demowater") {
      return device.signal_strength;
    }
    return device.scalar_value;
  };

  return (
    <>
      {shouldRenderDevice() ? (
        <>
          <tr key={uuidv4()} className="device-item">
            <td>{titleHunt === "HUNT" ? device.uuid : device.name}</td>
            <td>{device.meter_id}</td>
            <td>{titleHunt}</td>
            <td>{device.scalar_value ? `${device.scalar_value}kL` : ""}</td>
            {/* <td>{Math.round(device.total_usage * 100) / 100}kL</td> */}
            <td>{device.signal_strength}</td>
            {tenantConfig?.slug === "demowater" ? (
              <td>{device.link_quality}</td>
            ) : null}
            <td>{displaySeverity("On Time", "low")}</td>
            <td
              onClick={(event) =>
                downloadFile(date, device.intellihub_participant_codes)
              }
            >
              {displaySeverity(
                `${
                  tenantConfig.slug === "demowater"
                    ? `${device.intellihub_participant_codes.length} File${
                        device.intellihub_participant_codes.length !== 1
                          ? "s"
                          : ""
                      }`
                    : "File"
                }`,
                "file"
              )}
            </td>
            <td>
              <ResponsiveContainer width="67%" height={30}>
                <BarChart
                  data={device.usage_data}
                  margin={{ right: 10, left: 10, bottom: 0 }}
                  barCategoryGap={1}
                >
                  <Bar
                    dataKey="consumption"
                    fill="#0BA2B4"
                    barSize={7}
                    background={{ fill: "#ffffff" }} // white background column
                  />
                </BarChart>
              </ResponsiveContainer>
            </td>
            <td>{displaySeverity("Processed", "low")}</td>
          </tr>
        </>
      ) : (
        <>
          <tr key={uuidv4()}>
            <td className="statusError">
              {titleHunt === "HUNT" ? device.uuid : device.name}
            </td>
            <td>{device.meter_id}</td>
            <td>{titleHunt}</td>
            <td></td>
            {tenantConfig?.slug === "demowater" ? <td></td> : null}
            <td></td>
            <td></td>
            <td>{displaySeverity("No File", "warning")}</td>
            <td></td>
            <td>{displaySeverity("Not Processed", "warning")}</td>
          </tr>
        </>
      )}
    </>
  );
};

export default DeviceItem;
